import script from "./ProfileParentRelationshipModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileParentRelationshipModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileParentRelationshipModal.vue?vue&type=style&index=0&id=8f1b9914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f1b9914"]])

export default __exports__